export default {
    clearingHouseUrl: "https://data.catalogue.life/",
    dataApi: "https://api.catalogue.life/",
    catalogueKey: 3
}